import styled from "styled-components";

import { colorsPalettes, fonts, mixins } from "@similarweb/styles";

import { withSWReactIconFillColor } from "../../../../advanced-search/components/common-styles";
import SelectionDropdownView from "../../../../table-actions-panel/components/SelectionDropdown/SelectionDropdown";
import ActiveRevealActionButton from "../ActiveRevealActionButton/ActiveRevealActionButton";

export const StyledSelectionDropdown = styled(SelectionDropdownView)`
    margin-left: 20px;
`;

export const StyledSubmitButton = styled(ActiveRevealActionButton)`
    margin-left: 16px;
`;

export const StyledRevealPriceBadgeWrapper = styled.div`
    margin-left: 16px;
`;

export const StyledLabel = styled.span`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["0"],
        $weight: 700,
        $size: 14,
        $family: fonts.$dmSansFontFamily,
    })};
    margin-left: 4px;
`;

export const StyledEyeIcon = styled.div`
    margin-left: 32px;
    ${withSWReactIconFillColor(colorsPalettes.carbon["0"])};
`;

export const StyledPanel = styled.div`
    align-items: center;
    display: flex;
`;
